import React from "react";
import "./SkeletonLoader.css";

/**
 * SkeletonLoader Component
 * Displays a shimmer animation while content is loading
 *
 * @param {number} width - Width of skeleton (default: 100%)
 * @param {number} height - Height of skeleton (default: 200px)
 * @param {string} borderRadius - Border radius (default: 8px)
 * @param {string} className - Additional CSS class
 */
const SkeletonLoader = ({
  width = "100%",
  height = "200px",
  borderRadius = "8px",
  className = "",
}) => {
  return (
    <div
      className={`skeleton-loader ${className}`}
      style={{
        width,
        height,
        borderRadius,
      }}
    />
  );
};

export default SkeletonLoader;
